import Http from '../services/http.service';

const Util = {};
Util.checkUrl = async (url) => (await Http.get().get(`${process.env.VUE_APP_API}/1/util/url`, {params: {url}})).data;
export default Util;
